/**
 * Get the number of significant digits after the decimal.
 * @param {String|Number} num - Number in question.
 * @return {String}
 */

export default function significanFigureCount(num) {
  const decimals = String(num).split('.')[1]
  return decimals ? decimals.length : 0
}



// WEBPACK FOOTER //
// ./src/helpers/significantFigureCount.js